import Grid from "@mui/material/Grid";
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { AlojamientoCajasGenericasList } from "../components/AlojamientoCajasGenericasList";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import HomeWorkIcon from "@mui/icons-material/HomeWork";

export function AlojamientoCajasGenericas() {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Alojamiento de Cajas Genéricas" icon={<HomeWorkIcon />} />
      <CajasProvider>
        <Grid style={{ marginTop: "15px" }}>
          <AlojamientoCajasGenericasList />
        </Grid>
      </CajasProvider>
    </Grid>
  );
}
